import { useState } from "react";
import { Button } from "components/Button/styles";
import { Variant } from "components/Button";
import { Uppercase } from "styles/components";
import Rate, { RateSize, RateVariant } from '../../../Rate'
import { StepType } from "../..";
import * as S from './styles'
import * as T from '../../styles'

export const Step2 = ({number, currentStep, prevStep, nextStep}: StepType) => {

  const [rate, setRate] = useState<string | null>(null);

  const selectRate = (sel: string | null) => setRate(sel);

  const disabledNext = !rate;

  return (
    <S.Step isActive={number === currentStep}>
      <S.Content>
        <T.Title>Заполните форму о вашей компании</T.Title>
        <S.Cards>
          <Rate variant={RateVariant.BASE} size={RateSize.SMALL} isActive={rate === 'Base'} onClick={() => selectRate('Base')}>
            <Rate.Title>BASIC</Rate.Title>
            <Rate.Content>
                <Rate.Desc>Для небольшлого числа пользователейи низких  функциональных требований</Rate.Desc>
                <Rate.Item>
                    <Rate.Value>20</Rate.Value>
                    <Rate.Text>участников видеоконференции</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>250 Gb</Rate.Value>
                    <Rate.Text>для хранения данных</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>30 Days</Rate.Value>
                    <Rate.Text>срок хранения на сервере</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>24 h</Rate.Value>
                    <Rate.Text>отклик поддержки</Rate.Text>
                </Rate.Item>
            </Rate.Content>
            <Rate.Footer>
                <Rate.Button>CHF <S.CrossedText>7.90</S.CrossedText> 7.10</Rate.Button>
            </Rate.Footer>
          </Rate>
          <Rate variant={RateVariant.PRO} size={RateSize.SMALL} isActive={rate === 'Pro'} onClick={() => selectRate('Pro')}>
            <Rate.Title>PRO</Rate.Title>
            <Rate.Content>
                <Rate.Desc>Для небольшлого числа пользователейи низких  функциональных требований</Rate.Desc>
                <Rate.Item>
                    <Rate.Value>50</Rate.Value>
                    <Rate.Text>участников видеоконференции</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>500 Gb</Rate.Value>
                    <Rate.Text>для хранения данных</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>∞</Rate.Value>
                    <Rate.Text>срок хранения на сервере</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>12 h</Rate.Value>
                    <Rate.Text>отклик поддержки</Rate.Text>
                </Rate.Item>
            </Rate.Content>
            <Rate.Footer>
                <Rate.Button>CHF <S.CrossedText>15.90</S.CrossedText> 14.30</Rate.Button>
            </Rate.Footer>
          </Rate>
          <Rate variant={RateVariant.ENTERPRISE} size={RateSize.SMALL} isActive={rate === 'Enterprise'} onClick={() => selectRate('Enterprise')}>
            <Rate.Title>ENTERPRISE</Rate.Title>
            <Rate.Content>
                <Rate.Desc>Для небольшлого числа пользователейи низких  функциональных требований</Rate.Desc>
                <Rate.Item>
                    <Rate.Value>{'>'}100</Rate.Value>
                    <Rate.Text>участников видеоконференции</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>1 Tb</Rate.Value>
                    <Rate.Text>для хранения данных</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>∞</Rate.Value>
                    <Rate.Text>срок хранения на сервере</Rate.Text>
                </Rate.Item>
                <Rate.Item>
                    <Rate.Value>6 h</Rate.Value>
                    <Rate.Text>отклик поддержки</Rate.Text>
                </Rate.Item>
            </Rate.Content>
            <Rate.Footer>
                <Rate.Button>CHF <S.CrossedText>23.90</S.CrossedText> 21.50</Rate.Button>
            </Rate.Footer>
          </Rate>
        </S.Cards>
        <T.Buttons>
          <Button variant={Variant.Outline_Business} onClick={() => !!prevStep && prevStep()}><Uppercase>К предыдущему шагу</Uppercase></Button>
          <Button variant={Variant.Business} disabled={disabledNext} onClick={() => !!nextStep && nextStep(rate)}>
            <Uppercase>Выбрать тариф</Uppercase>
          </Button>
        </T.Buttons>
      </S.Content>
    </S.Step>
  )
}